export class ServerSyncInfoSettings {
  engagementId: string;
  noOfRecordsDownloaded: number;
  requestsDownloadedDate: Date;
  requestsRenderedDate: string;
  timePhaseMasterMetaData: string;
  requestUploadedDate: Date;
  selectedEntityType: number;
  activeSheetName: string;
  activeSheetId: string;
  engagementIdAndDescription : string;
  userLanguage: string;
  engagementLDCVersion: string;
  entitySelected: string;


  constructor(activeSheetId: string, engagementId: string) {
    this.activeSheetName = null;
    this.engagementId = engagementId;
    this.noOfRecordsDownloaded = 0;
    this.requestsDownloadedDate = null;
    this.requestsRenderedDate = null;
    this.timePhaseMasterMetaData = null;
    this.requestUploadedDate = null;
    this.selectedEntityType = null;
    this.activeSheetId = activeSheetId;
    this.engagementIdAndDescription = null;
    this.userLanguage = null;
    this.engagementLDCVersion = "";
    this.entitySelected = "";
  }
}
